import React, { useEffect, useState } from "react";
import "./index.less";
import MaterialTypesTable from "./materialTypesTable";
import { useSelector } from "react-redux";

const MaterialTypes = () => {
  const { user } = useSelector((state) => state.authReducer);
  const [canUpdate, setCanUpdate] = useState(false);

  useEffect(() => {
    // if (user?.permissions?.material_types?.add_edit) {
      setCanUpdate(true);
    // }
  }, [user]);

  return (
    <div className="page-top-div">
      <span className="text-span">Material Type</span>
      <MaterialTypesTable canUpdate={canUpdate} />
    </div>
  );
};

export default MaterialTypes;
